import styled from "styled-components"
import { mobile } from "../Responsive"
import {Link} from "react-router-dom"

const Container = styled.div`
    flex: 1;
    margin: 3px;
    position: relative;
`
const Image = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    ${mobile({height: "30vh"})}
`
const Info = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`
const Title = styled.h1`
    color: white;
    margin-bottom: 20px;
`
const Button = styled.button`
    border: 1px solid #404040;
    padding: 10px;
    background-color: transparent;
    color: white;
    cursor: pointer;
    font-weight: 600;

    &:hover{
        background-color: #404040;
        color: white;
    }
`

const CategoriesItem = ({item}) => {
  return (
    <Container>
        <Link to={`/products/${item.cat}`}>
        <Image src={item.img}/>
        <Info>
            <Title>{item.title}</Title>
            <Button>SHOP NOW</Button>
        </Info>
        </Link>
    </Container>
  )
}

export default CategoriesItem